export default __webpack_public_path__ + "static/media/premium.d89c3eec.png";